import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, IconButton, Box, Slide
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { postData } from "../../BaseUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CheckOutReasonDialog = ({ open, onClose, item, onSuccess }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!item) return null;

  const handleSubmit = async () => {
    if (!reason.trim()) {
      setError("Please provide a reason for check-out");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await postData(`admin/inventory/${item.id}/check-out`, { reason });
      onSuccess(`${item.itemName || item.name} checked out successfully`);
      setReason("");
    } catch (err) {
      setError(err?.response?.data?.message || "Check-out failed");
    }
    setLoading(false);
  };

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth TransitionComponent={Transition}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          <Typography variant="h6" fontWeight="bold">Check Out Item</Typography>
          <Typography variant="body2" color="text.secondary">
            {item.itemName || item.name} - #{item.itemId || item.id}
          </Typography>
        </Box>
        <IconButton onClick={handleClose}><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <TextField fullWidth size="small" multiline rows={4}
          label="Reason Description"
          placeholder="Please describe the reason for checking out this item..."
          value={reason} onChange={(e) => setReason(e.target.value)}
          sx={{ mt: 1 }} />
        {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="outlined" color="inherit"
          sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)", textTransform: "none" }}>
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckOutReasonDialog;
